// src/App.jsx

import { TopBar } from './components/Layout/TopBar';
import { RoomNav } from './components/Layout/RoomNav';
import { Cursor } from './components/Layout/Cursor';
import { Particles } from './components/Layout/Particles';
import { ProgressBar } from './components/Layout/ProgressBar';
import { Hero } from './components/Sections/Hero';
import { Manifest } from './components/Sections/Manifest';
import { Room } from './components/Sections/Room';
import { Gallery } from './components/Sections/Gallery';
import { Footer } from './components/Sections/Footer';
import { SkipLink } from './components/UI/SkipLink';
import { useLenis } from './hooks/useLenis';
import { ScrollToTopButton } from './components/UI/ScrollToTopButton';
import { SocialHub } from './components/Layout/SocialHub';

function App() {
  useLenis(); // Initialize smooth scroll

  return (
    <div className="relative min-h-screen bg-[var(--bg)] text-[var(--text)]">
      {/* Accessibility Skip Link */}
      <SkipLink target="#room-hero" />
      
      {/* Global Elements */}
      <ProgressBar />
      <TopBar />
      <RoomNav />
      <Cursor />
      <Particles />
      <div className="grain" aria-hidden="true" />

      {/* Main Content */}
      <main id="main-content">
        <Hero />
        <Manifest />
        <Room roomId="room1" />
        <Room roomId="room2" />
        <Room roomId="room3" />
        <Gallery />
      </main>
      <SocialHub />
      <ScrollToTopButton />
      <Footer />
    </div>
  );
}

export default App;